import { changeUserStatusApi } from "./changeUserStatusApi";

export const changeUserStatusSetData = async (
  lang,
  setMessageResponse,
  cookies,
  credintial,
  setSuccessMessage
) => {
  const response = await changeUserStatusApi(credintial, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "add",
      data: response.res.data,
    }));
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
